import { NgeExplorerConfig } from './types';

export const Config: NgeExplorerConfig = {
    homeNodeName: 'Files'
};
